module.exports = __webpack_public_path__ + "static/media/mediaPictureBlank.cb68e133.png";